import React, { createContext, useContext, useEffect, useState } from "react";
import { SEASON_SETTINGS } from "../data/seasons";
import { request } from "../services/api";

const SeasonContext = createContext(SEASON_SETTINGS);

const REFRESH_EVERY = 10 * 60 * 1000;

// The seasonal theme settings, as set from the admin dashboard through the
// API (GET /api/settings/season). Until the API answers — or if it can't be
// reached — no theme is shown, so a switched-off theme never flashes on load.
export function SeasonProvider({ children }) {
  const [settings, setSettings] = useState({ ...SEASON_SETTINGS, mode: "off", loaded: false });

  useEffect(() => {
    let alive = true;
    const load = () =>
      request("GET", "/settings/season")
        .then((remote) => alive && setSettings({ ...SEASON_SETTINGS, ...remote, loaded: true }))
        .catch(() => alive && setSettings((current) => (current.loaded ? current : { ...SEASON_SETTINGS, loaded: true })));
    load();
    const timer = setInterval(load, REFRESH_EVERY);
    return () => {
      alive = false;
      clearInterval(timer);
    };
  }, []);

  return <SeasonContext.Provider value={settings}>{children}</SeasonContext.Provider>;
}

export const useSeasonSettings = () => useContext(SeasonContext);
